'use client';

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { interpolate } from '@format/interpolate';
import { useShopifyOfferContext } from '../../offer/shopifyContext';
import { TypewriterContainer, Text, Cursor } from './styles';

export const Typewriter = ({
  words = [],
  typography = 'heading1',
  fontColor = 'hero.lilac',
}) => {
  const { formattedAmount } = useShopifyOfferContext();
  const [currentText, setCurrentText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    if (!words || words.length === 0) return;

    let timeoutId;
    const currentWord = interpolate(words[currentIndex], {
      offer: formattedAmount,
    });

    if (isDeleting) {
      if (currentText === '') {
        timeoutId = setTimeout(() => {
          setIsDeleting(false);
          setCurrentIndex(prev => (prev + 1) % words.length);
        }, 120);
      } else {
        timeoutId = setTimeout(() => {
          setCurrentText(prev => prev.slice(0, -1));
        }, 30);
      }
    } else {
      if (currentText === currentWord) {
        timeoutId = setTimeout(() => {
          setIsDeleting(true);
        }, 1200);
      } else {
        timeoutId = setTimeout(() => {
          setCurrentText(
            interpolate(currentWord.slice(0, currentText.length + 1), {
              offer: formattedAmount,
            }),
          );
        }, 55);
      }
    }

    return () => clearTimeout(timeoutId);
  }, [currentText, isDeleting, currentIndex, formattedAmount, words]);

  return (
    <TypewriterContainer $typography={typography} $fontColor={fontColor}>
      <Text>{currentText}</Text>
      <Cursor $fontColor={fontColor} aria-hidden="true"></Cursor>
    </TypewriterContainer>
  );
};

Typewriter.propTypes = {
  words: PropTypes.arrayOf(PropTypes.string).isRequired,
  typography: PropTypes.string,
  fontColor: PropTypes.string,
};
